import React from 'react';
import { useTranslation } from 'react-i18next';

import AuthLayout from '../AuthLayout';
import LoginForm from '../Forms/LoginForm';

import styles from './styles.scss';

export default function LoginPage() {
    const { t } = useTranslation('auth');

    return (
        <AuthLayout>
            <div className={styles.root}>
                <div className={styles.header}>
                    <h1>{t('auth.signin.heading')}</h1>
                </div>
                <LoginForm />
            </div>
        </AuthLayout>
    );
}
